var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg1F4B3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M4 5C1.791 5 0 6.791 0 9v18c0 2.209 1.791 4 4 4h28c2.209 0 4-1.791 4-4V9s0-4-4-4H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M0 10h36v5H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7F9",
    d: "M4 19h28v6H4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8899A6",
    d: "M19 24c-1.703 0-2.341-1.21-2.469-1.801-.547.041-1.08.303-1.805.764C13.961 23.449 13.094 24 12 24c-1.197 0-1.924-.675-2-2-.003-.056.038-.188.021-.188-1.858 0-3.202 1.761-3.215 1.779-.195.267-.499.409-.806.409-.206 0-.413-.063-.591-.194-.445-.327-.542-.953-.215-1.398C5.271 22.303 7.11 20 10 20c1.937 0 2.048 1.375 2.078 1.888l.007.109c.486-.034.991-.354 1.57-.723.961-.61 2.153-1.371 3.75-.962.871.223 1.007 1.031 1.059 1.336.013.076.032.19.049.226.007 0 .146.091.577.13.82.075 1.721-.279 2.675-.653.988-.388 2.01-.788 3.111-.788 3.389 0 4.767 1.635 4.913 1.821.34.435.264 1.063-.171 1.403-.175.137-.381.207-.587.213-.307.009-.613-.123-.817-.384-.024-.027-.93-1.054-3.337-1.054-.723 0-1.528.315-2.381.649-1.009.396-2.434.789-3.496.789z"
  })));
}

export default Svg1F4B3;